import dateformat from "dateformat";

/* eslint import/prefer-default-export: off */
export const formatDate = datestr => dateformat(new Date(datestr), "mmm yyyy");



// WEBPACK FOOTER //
// ./src/utils.js